import React from 'react';
import {
  TextInput,
  SimpleForm,
  Edit,
  ReferenceInput,
  SelectInput,
  AutocompleteInput,
  DateInput
} from "react-admin";

import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import {
  LocalShipping,
  ShoppingBasket,
  LocalOffer,
  Today,
  Archive,
  PersonPinCircle,
  Star
} from "@material-ui/icons/";

import { styles } from "../../layout/Styles";

export class PesajeEditComponent extends React.Component {
  render() {
    const props = this.props;
    return(
      <Edit title="Editar Peso" {...props}>
        <SimpleForm>
          <Grid style={styles.createContent}>
            <Grid container spacing={0}>
              <Grid item s={12} md={4}>
                <Paper style={styles.paperIcon}>
                  <Star style={styles.iconLeft} />
                  <ReferenceInput
                    label="Predio"
                    reference="predios"
                    source="predio"
                    sort={{ field: 'nombre', order: 'ASC' }}
                  >
                      <SelectInput optionText="nombre" optionValue="_id" fullWidth />
                  </ReferenceInput>
                </Paper>
                <Paper style={styles.paperIcon}>
                  <ShoppingBasket style={styles.iconLeft} />
                  <ReferenceInput
                    label="Pesador"
                    reference="operarios"
                    source="pesador"
                    sort={{ field: 'nombre', order: 'ASC' }}
                  >
                      <SelectInput optionText="nombre" optionValue="_id" fullWidth />
                  </ReferenceInput>
                </Paper>
                <Paper style={styles.paperIcon}>
                  <LocalShipping style={styles.iconLeft} />
                  <TextInput label="Camión" source="camion" fullWidth autoFocus />
                </Paper>
                <Paper style={styles.paperIcon}>
                  <PersonPinCircle style={styles.iconLeft} />
                  <ReferenceInput reference="etapas" source="etapa" perPage={100} sort={{ field: 'nombre', order: 'ASC' }}>
                      <SelectInput  optionText="nombre" optionValue="nombre" fullWidth />
                  </ReferenceInput>
                </Paper>
                <Paper style={styles.paperIcon}>
                  <Today style={styles.iconLeft} />
                  <DateInput label="fecha" source="fecha" fullWidth />
                </Paper>
              </Grid>
              <Grid item s={12} md={4}>
                <Paper style={styles.paperIcon}>
                  <LocalOffer style={styles.iconLeftBig} />
                  <TextInput label="Número de bolsón" source="bolson" fullWidth />
                  <div className="fullWidth">
                    <ReferenceInput
                      label="Recuperador"
                      reference="recuperadores"
                      source="cartonero"
                      sort={{ field: 'nombre', order: 'ASC' }}
                      filterToQuery={searchText => ({ searchnombre: searchText })}
                      options={{ fullWidth: true, }}
                    >
                        <AutocompleteInput optionText="nombre" optionValue="_id" options={{ fullWidth: true, }} />
                    </ReferenceInput>
                  </div>
                  <div className="fullWidth">
                    <ReferenceInput
                      label="Material"
                      reference="materiales"
                      source="material"
                      filter={{enPesajes: true}}
                      sort={{ field: 'nombre', order: 'ASC' }}
                    >
                      <SelectInput optionText="nombre" optionValue="_id" fullWidth />
                    </ReferenceInput>
                  </div>
                </Paper>
              </Grid>
              <Grid item s={12} md={4}>
                <Paper style={styles.paperIcon} elevation="3">
                  <Archive style={styles.iconLeft} />
                  <TextInput label="Peso (Kgs.)" source="peso" fullWidth />
                </Paper>
                <Paper style={styles.paper}>
                  <TextInput label="Comentario" source="comentario" fullWidth />
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </SimpleForm>
      </Edit>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Pesajes/PesajeEditComponent.js